<template>
  <div>
    <div>
      <table class="cash-control-table">
        <tr style="border: 1px solid grey">
          <td class="text-center">Banconote (nr. PEZZI)</td>
          <td style="border-left: 1px solid grey; padding: 30px 0">
            <ul style="list-style-type: none; padding: 0 40px; margin: 0">
              <li style="margin-bottom: 15px">
                <div class="d-flex align-items-center" style="gap: 10px">
                  <img
                    :src="require('@/assets/bills/fiveHundredE.jpg')"
                    width="60"
                  />
                  <span style="min-width: 60px">500 euro: </span>
                  <b-form-input
                    style="max-width: 120px"
                    type="number"
                    v-model="fivehundred"
                  ></b-form-input>
                </div>
              </li>
              <li style="margin-bottom: 15px">
                <div class="d-flex align-items-center" style="gap: 10px">
                  <img
                    :src="require('@/assets/bills/twoHundredE.jpg')"
                    width="60"
                  />
                  <span style="min-width: 60px">200 euro: </span>
                  <b-form-input
                    style="max-width: 120px"
                    type="number"
                    v-model="twohundred"
                  ></b-form-input>
                </div>
              </li>
              <li style="margin-bottom: 15px">
                <div class="d-flex align-items-center" style="gap: 10px">
                  <img
                    :src="require('@/assets/bills/hundredE.jpg')"
                    width="60"
                  />
                  <span style="min-width: 60px">100 euro: </span>
                  <b-form-input
                    style="max-width: 120px"
                    type="number"
                    v-model="hundred"
                  ></b-form-input>
                </div>
              </li>
              <li style="margin-bottom: 15px">
                <div class="d-flex align-items-center" style="gap: 10px">
                  <img :src="require('@/assets/bills/fiftyE.jpg')" width="60" />
                  <span style="min-width: 60px">50 euro: </span>
                  <b-form-input
                    style="max-width: 120px"
                    type="number"
                    v-model="fifty"
                  ></b-form-input>
                </div>
              </li>
              <li style="margin-bottom: 15px">
                <div class="d-flex align-items-center" style="gap: 10px">
                  <img
                    :src="require('@/assets/bills/twentyE.jpg')"
                    width="60"
                  />
                  <span style="min-width: 60px">20 euro: </span>
                  <b-form-input
                    style="max-width: 120px"
                    type="number"
                    v-model="twenty"
                  ></b-form-input>
                </div>
              </li>
              <li style="margin-bottom: 15px">
                <div class="d-flex align-items-center" style="gap: 10px">
                  <img :src="require('@/assets/bills/tenE.jpg')" width="60" />
                  <span style="min-width: 60px">10 euro: </span>
                  <b-form-input
                    style="max-width: 120px"
                    type="number"
                    v-model="ten"
                  ></b-form-input>
                </div>
              </li>
              <li>
                <div class="d-flex align-items-center" style="gap: 10px">
                  <img :src="require('@/assets/bills/fiveE.jpg')" width="60" />
                  <span style="min-width: 60px">5 euro: </span>
                  <b-form-input
                    style="max-width: 120px"
                    type="number"
                    v-model="five"
                  ></b-form-input>
                </div>
              </li>
            </ul>
          </td>
        </tr>
        <tr style="border: 1px solid grey">
          <td class="text-center">Monete (Totale)</td>
          <td style="border-left: 1px solid grey; padding: 30px 0">
            <div
              class="d-flex align-items-center"
              style="gap: 10px; padding: 0 40px"
            >
              <span
                style="
                  min-width: 60px;
                  width: calc(60px + 10px + 60px);
                  padding-left: 47px;
                "
                >Totale euro:
              </span>
              <b-form-input
                style="max-width: 120px"
                v-model="totalCoins"
              ></b-form-input>
            </div>
          </td>
        </tr>
        <tr style="border: 1px solid grey">
          <td class="text-center">Assegni (Totale)</td>
          <td style="border-left: 1px solid grey; padding: 30px 0">
            <div
              class="d-flex align-items-center"
              style="gap: 10px; padding: 0 40px"
            >
              <span
                style="
                  min-width: 60px;
                  width: calc(60px + 10px + 60px);
                  padding-left: 47px;
                "
                >Totale euro:
              </span>
              <b-form-input
                style="max-width: 120px"
                v-model="totalAssign"
              ></b-form-input>
            </div>
          </td>
        </tr>
        <tr style="border: 1px solid grey">
          <td class="text-center">Totalizzatori</td>
          <td style="border-left: 1px solid grey; padding: 30px 0">
            <div
              class="d-flex align-items-center"
              style="position: relative"
              data-type="cash-control"
            >
              <div class="custom-grid-wrapper">
                <div class="even grid-item-label">
                  <strong>Totale contanti</strong>
                </div>
                <div class="even grid-item-value">
                  <span>{{ toLocaleCurrency(totalCash) }}</span>
                </div>
                <div class="odd grid-item-label">
                  <strong>Totale complessivo</strong>
                </div>
                <div class="odd grid-item-value">
                  <span>{{ toLocaleCurrency(generalTotal) }}</span>
                </div>
                <div class="even grid-item-label">
                  <strong>Totale quadratura {{ label }}</strong>
                </div>
                <div class="even grid-item-value">
                  <span>{{ toLocaleCurrency(totals) }}</span>
                </div>
                <div
                  :class="`odd grid-item-label${
                    differenceTotals < 0 ? ' text-danger' : ''
                  }`"
                >
                  <strong>Differenza</strong>
                </div>
                <div
                  :class="`odd grid-item-value${
                    differenceTotals < 0 ? ' text-danger' : ''
                  }`"
                >
                  <span>{{ toLocaleCurrency(differenceTotals) }}</span>
                </div>
              </div>
              <span
                style="
                  position: absolute;
                  top: 50%;
                  right: 20px;
                  translate: 0 -50%;
                  border: 2px solid red;
                  height: fit-content;
                  padding: 10px 20px;
                  border-radius: 4px;
                  font-size: 14px;
                  font-weight: 500;
                "
                v-if="differenceTotals"
                class="text-danger"
                >Attenzione! Incongruenza!</span
              >
              <span
                style="
                  position: absolute;
                  top: 50%;
                  right: 20px;
                  translate: 0 -50%;
                  border: 2px solid green;
                  height: fit-content;
                  padding: 10px 20px;
                  border-radius: 4px;
                  font-size: 14px;
                  font-weight: 500;
                "
                v-else
                class="text-success"
                >Coerenza di cassa!</span
              >
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import { toLocaleCurrency } from "@/utils/strings";
export default {
  data() {
    return {
      five: 0,
      ten: 0,
      twenty: 0,
      fifty: 0,
      hundred: 0,
      twohundred: 0,
      fivehundred: 0,
      totalCoins: 0,
      totalAssign: 0,
    };
  },
  props: {
    totals: null,
  },
  computed: {
    totalCash() {
      return this.getTotalCash();
    },
    generalTotal() {
      return (
        this.getTotalCash() +
        Number(this.totalAssign ? this.totalAssign.replace(",", ".") : "0")
      );
    },
    differenceTotals() {
      return this.generalTotal.toFixed(2) - this.totals.toFixed(2);
    },
  },
  methods: {
    toLocaleCurrency,
    getTotalCash() {
      return (
        this.five * 5 +
        this.ten * 10 +
        this.twenty * 20 +
        this.fifty * 50 +
        this.hundred * 100 +
        this.twohundred * 200 +
        this.fivehundred * 500 +
        Number(this.totalCoins ? this.totalCoins.replace(",", ".") : "0")
      );
    },
  },
};
</script>
<style lang="scss" scoped>
// Importi: totalizzatori e campi in euro (i campi number sono pezzi).
// Sui campi serve font-family: il reboot di Bootstrap vi mette inherit, che
// prevale sulla regola * di custom.scss.
.grid-item-value {
  --font-family: var(--font-family-num);
}
input[type="text"] {
  font-family: var(--font-family-num);
}

input[type="number"],
input[type="text"] {
  text-align: right;
}
input[type="text"] {
  padding-right: 24px;
}
[data-type="cash-control"] .custom-grid-wrapper {
  grid-template-columns: 230px 1fr;
}
[data-type="cash-control"] .custom-grid-wrapper .grid-item-label * {
  text-indent: 5px;
  display: block;
  white-space: nowrap;
}
[data-type="cash-control"] .custom-grid-wrapper .grid-item-value {
  text-align: right;
  padding-right: 20px;
}
[data-type="cash-control"] .custom-grid-wrapper .grid-item-value.odd {
  background: var(--color-bg);
  box-shadow: 0 0 0 100vmax var(--color-bg);
}
@media (hover: hover) and (pointer: fine) {
  body {
    [data-type="cash-control"] {
      .custom-grid-wrapper {
        // &.details-card {
        .grid-item-label {
          &:hover {
            & + .grid-item-value {
              box-shadow: 0 0 0 100vmax var(--lisaweb-light);
              background: var(--lisaweb-light);
            }
          }

          & + .grid-item-value {
            &:hover {
              box-shadow: 0 0 0 100vmax var(--lisaweb-light);
              background: var(--lisaweb-light);
            }
          }
        }

        // }
      }
    }
  }
}
.cash-control-table {
  width: 100%;
  font-weight: 500;
  tr {
    td {
      &:first-child {
        width: 20%;
      }
    }
  }
}
</style>
